import { gql, useMutation } from '@apollo/client'
import { prop, map, assoc } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { cleanRequest } from './cleanRequest'
import { generalClient } from '../../../../utils/apollo/api'
import { isUrlValid } from '../../../../utils/helpers/string'
import { useLinkTreeForm } from '../_form/LinkTreeFormHandler'
import { useModalData, useMoveBack } from '../../../../components/modals/ModalsContext'
import { useAlert } from '@btime/react-messager'

const MUTATION = gql`
  mutation UpsertLinkTreeItems($inputs: [LinkTreeItemInput]) {
    upsertLinkTreeItems(inputs: $inputs) {
      id
    }
  }
`

const hasInvalidUrl = items => {
  for (const item of items) {
    if (!item?.configuration?.isPublicHistory && !isUrlValid(item.url)) {
      return true
    }
  }

  return false
}

const hasInvalidQuestionToHistory = items => {
  for (const item of items) {
    const configuration = item?.configuration
    if (
      configuration?.isPublicHistory &&
      (!Array.isArray(configuration?.filter?.questions) || configuration?.filter?.questions?.length < 1)
    ) {
      return true
    }
  }

  return false
}

const useValidator = items => {
  const { t } = useTranslation('editLinkTreeItems')
  const [msg, setMsg] = React.useState()

  return [
    () => {
      if (items.some(item => !item.label)) return setMsg(t('validation.fillAllNames'))
      if (items.some(item => !item.url)) return setMsg(t('validation.fillAllUrls'))
      if (hasInvalidQuestionToHistory(items)) return setMsg(t('validation.fillChecklistForHistory'))
      if (hasInvalidUrl(items)) return setMsg(t('validation.invalidUrls'))
      if (items.filter(prop('isDefault')).length > 1) return setMsg(t('validation.multipleAutoRedirects'))

      return true
    },
    msg
  ]
}

export const useSaveLinkTree = () => {
  const { t } = useTranslation('editLinkTreeItems')
  const linkTree = useModalData()
  const modal = useAlert()
  const moveBack = useMoveBack()
  let { linkTreeItems } = useLinkTreeForm()
  linkTreeItems = map(assoc('linkTreeId', linkTree.id))(linkTreeItems)
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['LinkTreeItems'], client: generalClient })

  const [validate, validationMsg] = useValidator(linkTreeItems)

  const handleRequest = () => {
    const inputs = cleanRequest(linkTreeItems)

    if (!validate()) return false

    if (Array.isArray(inputs) && inputs.length === 0) {
      if (modal.confirm({ title: t('validation.confirmSaveWithoutCustomLink') })) {
        moveBack()
      }
      return false
    }

    return request({ variables: { inputs } }).then(resp => {
      if (!resp.errors) {
        moveBack()
      }
    })
  }

  return [handleRequest, { ...state, validation: validationMsg }]
}
